import { EmptyState } from '@app/components/base/EmptyState';
import { ComposeCreateCompositionLink } from '@app/modules/compose/components/ComposeCreateCompositionLink';
import { Stack } from '@mui/material';
import { defineMessage, useIntl } from 'react-intl';

const composeListEmptyStateMessage = defineMessage({
  id: 'compose.listEmptyState.message',
  defaultMessage: 'No hay composiciones',
});

/**
 * Empty list state for the compose grid: CTA to create a composition and optional reset filters.
 */
export function CompositionsListEmptyState({ stationSlug }: { stationSlug: string }) {
  const { $t } = useIntl();

  return (
    <EmptyState
      message={$t(composeListEmptyStateMessage)}
      action={
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center">
          <ComposeCreateCompositionLink stationSlug={stationSlug} />
        </Stack>
      }
    />
  );
}
